import React from "react";
import { ChartIcon } from "../../../excel/charts/api";

/** Fixed so every chart icon lines up in the drawer and on the cards. */
const CHART_ICON_SIZE = 28;

/**
 * Renders the icon a chart type or option declares. `excel/charts/` returns the asset as data so it
 * stays free of React; this is the only place that turns one into an element.
 */
const ChartIconImage: React.FC<{ icon: ChartIcon }> = ({ icon }) => (
  <img
    src={icon.src}
    alt={icon.alt}
    width={CHART_ICON_SIZE}
    height={CHART_ICON_SIZE}
    style={icon.rotated ? { transform: "rotate(90deg)" } : undefined}
  />
);

export default ChartIconImage;
